<div class="border-b p-1 g-surface-quaternary shrink-0">
  <soft-ds-progress-steps
    [steps]="steps()"
    [currentIndex]="navTabIndex()"
  ></soft-ds-progress-steps>
</div>

<div class="px-2">
  @if (navTabIndex() === 0) {
    <soft-sales-customer-step
      [data]="documentData()"
      [isEmbedded]="true"
      (dataChange)="documentData.set($event)"
      (next)="onNext($event)"
      (create)="onCreate($event)"
    />
  }

  @if (navTabIndex() === 1) {
    <soft-sales-construction-site-step
      [data]="documentData()"
      [isEmbedded]="true"
      (dataChange)="documentData.set($event)"
      (next)="onNext($event)"
      (create)="onCreate($event)"
    />
  }

  @if (navTabIndex() === 2) {
    <soft-sales-delivery-type-step
      [data]="documentData()"
      [isEmbedded]="true"
      (dataChange)="onDeliveryTypeChange($event)"
      (next)="onNext($event)"
      (create)="onCreate($event)"
    />
  }
</div>
